import { render, staticRenderFns } from "./demoUserMultiSelectTable.vue?vue&type=template&id=219d9f14&scoped=true&"
import script from "./demoUserMultiSelectTable.vue?vue&type=script&lang=js&"
export * from "./demoUserMultiSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219d9f14",
  null
  
)

export default component.exports